var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06884 11.3725C9.28102 11.1652 9.6197 11.1646 9.83257 11.3712L12.0001 13.4747L14.1676 11.3712C14.3805 11.1646 14.7191 11.1652 14.9313 11.3725C15.1516 11.5877 15.151 11.9423 14.93 12.1568L12.0001 15L9.07018 12.1568C8.84913 11.9423 8.84853 11.5877 9.06884 11.3725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.d2be19b0d0023531bd084e5cbcad532e.svg";
export { ForwardRef as ReactComponent };